import JobProposeForm from '../modules/forms/jobs/propose';

export default function setProposalScripts () {
    if (!window.location.pathname.includes('/propose/')) return;

    if (document.querySelector('#job-proposal-form')) {
        new JobProposeForm('#job-proposal-form');
    }
}
